export const getDefaultInternalAccessories = () => ({
    Four_in_one_sensor: {
        isDistanceSensors: false,
        isGestureSensor: false,
        isLightSensor: false,
        isColorSensor: false,
    },
    isFour_in_one_sensor: false,

    isMic: false,
    isTemperature: false,
    isBattery: false,
    isAccelerometer: false,

    isSwitch1: false,
    isSwitch2: false,

    isIr: false,
    isJoystick: false,

    // input
    isTouchZero: false,
    isTouchOne: false,
    isTouchTwo: false,
    isTouchThree: false,

    // output
    isTouchZeroOutput: false,
    isTouchOneOutput: false,
    isTouchTwoOutput: false,
    isTouchThreeOutput: false,

    isEYES: false,
    isLeftEye: false,
    isRightEye: false,
    isbuzzer: false,

    isSmileOne: false,
    isSmileTwo: false,
    isSmileThree: false,
    isSmileFour: false,

    isAtrMotor1: false,
    isAtrMotor2: false,
    isAtrMotor3: false,

    // woofKit outputs
    isIndivdualServo: false,
    isActionGroup: false,
    isWoofOled: false,
})

export var internalaccessoriesObj = getDefaultInternalAccessories()

/**
 * Clears every accessory on the shared singleton (including any key added to it
 * at runtime) and returns a detached all-false copy safe to dispatch to redux.
 */
export const resetInternalAccessoriesObj = () => {
    Object.keys(internalaccessoriesObj).forEach((key) => {
        if (key === 'Four_in_one_sensor') {
            Object.keys(internalaccessoriesObj.Four_in_one_sensor).forEach(
                (sensor) => {
                    internalaccessoriesObj.Four_in_one_sensor[sensor] = false
                }
            )
        } else {
            internalaccessoriesObj[key] = false
        }
    })

    return {
        ...internalaccessoriesObj,
        Four_in_one_sensor: { ...internalaccessoriesObj.Four_in_one_sensor },
    }
}
